import { Locale } from '@ps-smart-cp/ppfw-client';

const quantityUnitNameConfig = {
  piece: new Map([
    [Locale.ja, '個'],
    [Locale.en, 'Piece'],
  ]),
  unit: new Map([
    [Locale.ja, '台'],
    [Locale.en, 'Unit'],
  ]),
  house: new Map([
    [Locale.ja, '軒'],
    [Locale.en, 'House'],
  ]),
  setting: new Map([
    [Locale.ja, '式'],
    [Locale.en, 'Setting'],
  ]),
} satisfies Record<string, Map<Locale, string>>;

export { quantityUnitNameConfig };
